import React from 'react';
import { IconProps } from './types';

const PhoneInTalkIcon = (props: IconProps) => {
  const { fillColor = '#00BA34' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask
        id="mask0_8167_64279"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8167_64279)">
        <path
          d="M12.6667 7.96875C12.6667 6.66875 12.2139 5.56597 11.3083 4.66042C10.4028 3.75486 9.3 3.30208 8 3.30208V1.96875C8.83333 1.96875 9.61389 2.12708 10.3417 2.44375C11.0694 2.76042 11.7028 3.18819 12.2417 3.72708C12.7806 4.26597 13.2083 4.89931 13.525 5.62708C13.8417 6.35486 14 7.13542 14 7.96875H12.6667ZM10 7.96875C10 7.41319 9.80556 6.94097 9.41667 6.55208C9.02778 6.16319 8.55556 5.96875 8 5.96875V4.63542C8.92222 4.63542 9.70833 4.96042 10.3583 5.61042C11.0083 6.26042 11.3333 7.04653 11.3333 7.96875H10ZM13.3 14.0021C11.9111 14.0021 10.5389 13.6993 9.18333 13.0938C7.82778 12.4882 6.59444 11.6299 5.48333 10.5188C4.37222 9.40764 3.51389 8.17431 2.90833 6.81875C2.30278 5.46319 2 4.09097 2 2.70208C2 2.50208 2.06667 2.33542 2.2 2.20208C2.33333 2.06875 2.5 2.00208 2.7 2.00208H5.4C5.55556 2.00208 5.69444 2.05486 5.81667 2.16042C5.93889 2.26597 6.01111 2.39097 6.03333 2.53542L6.46667 4.86875C6.48889 5.04653 6.48333 5.19653 6.45 5.31875C6.41667 5.44097 6.35556 5.54653 6.26667 5.63542L4.65 7.26875C4.87222 7.67986 5.13611 8.07708 5.44167 8.46042C5.74722 8.84375 6.08333 9.21319 6.45 9.56875C6.79444 9.91319 7.15556 10.2326 7.53333 10.5271C7.91111 10.8215 8.31111 11.091 8.73333 11.3354L10.3 9.76875C10.4 9.66875 10.5306 9.59375 10.6917 9.54375C10.8528 9.49375 11.0111 9.47986 11.1667 9.50208L13.4667 9.96875C13.6222 10.0132 13.75 10.0938 13.85 10.2104C13.95 10.3271 14 10.4576 14 10.6021V13.3021C14 13.5021 13.9333 13.6688 13.8 13.8021C13.6667 13.9354 13.5 14.0021 13.3 14.0021Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default PhoneInTalkIcon;
